export default {
    global: 'Global',
    my_school: 'Mi colegio',
}
